export interface WasteStreamDotDescriptionSource {
  eManifestDotDescription?: string | null;
  vendorDotDescription?: string | null;
  groupingProfile?: { source?: string | null; value?: string | null } | null;
}

/**
 * A waste stream's single DOT Description value, as the stream drawer shows it.
 * When the stream was grouped on DOT printed text, that grouping value is shown
 * (it can differ from the column value); otherwise topline precedence picks
 * e-Manifest over Vendor.
 */
export function formatWasteStreamDotDescription(stream: WasteStreamDotDescriptionSource): {
  text: string;
  isGroupingKey: boolean;
} {
  const source = stream.groupingProfile?.source;
  const isGroupingKey =
    source === "vendorDotPrintedInformation" || source === "eManifestDotPrintedInformation";
  if (isGroupingKey) {
    return { text: stream.groupingProfile?.value ?? "", isGroupingKey };
  }
  return {
    text: stream.eManifestDotDescription || stream.vendorDotDescription || "",
    isGroupingKey,
  };
}
